import React from 'react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Page from '../../../components/page/page'
import PageHeader from '../../../components/page/pageHeader'
import { CustomIframe } from '../../../components/shared/customIframe/customIframe'
import { getActiveBalanceZone, getActiveCompany, getCustomerDomain } from '../../../redux'

export interface AtrDistributionPageProps {}

export const AtrDistributionPage: React.FC<AtrDistributionPageProps> = props => {
  const apiSuffixUrl = 'https://' + getCustomerDomain()
  const [t] = useTranslation(['globalerisLibrary', 'translation', 'guarantees'])

  // const apiSuffixUrl = 'https://localhost:44394';
  let activeCompany = getActiveCompany()
  let activeBalanceZone = getActiveBalanceZone()
  const [routeLocal, setRouteLocal] = useState(`${apiSuffixUrl}/Garantias/AtrDistribucion`)

  useEffect(() => {
    call()
  }, [activeCompany, activeBalanceZone])

  const call = async () => {
    setRouteLocal(
      `${apiSuffixUrl}/company/index/${activeCompany?.id}?idBalanceZone=${activeBalanceZone?.id}&company=${activeCompany?.description}&balanceZoneDescription=${activeBalanceZone?.description}`
    )

    setTimeout(() => {
      setRouteLocal(`${apiSuffixUrl}/Garantias/AtrDistribucion`)
    }, 1000)
  }

  return (
    <Page>
      <PageHeader title={t('guarantees:atrDistribution')} />
      <CustomIframe
        route={decodeURI(routeLocal)}
        width="100%"
        height="1200"
        allowFullScreen={true}
      />
    </Page>
  )
}
